import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {GetCorrectionReportsAction, analysisProtocolCorrectionAction} from '../action';

const tableId = 'analysisProtocolCorrectionOverview';

function* execute({payload: {tableDataRequest}}: GetCorrectionReportsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getCorrectionReports,
        successAction: analysisProtocolCorrectionAction.getCorrectionReportsSuccess,
        tableId,
    }));
}

/** Watches APC overview fetch requests and refreshes the connected table. */
export function* getCorrectionReportsSaga(): SagaIterator {
    yield takeLatestF('analysisProtocolCorrection/GET_CORRECTION_REPORTS', execute);
}
